define('core/style',["exports", "deps/text!core/css/respec2.css"], function (exports, _respec) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;

  var _respec2 = _interopRequireDefault(_respec);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  const name = exports.name = "core/style";

  // Opportunistically inserts the style, with the chance to reduce some FOUC
  // Module core/style
  // Inserts the CSS that ReSpec uses into the document.
  //
  // IMPORTANT NOTE
  //  To add you own styles, create a plugin that declares the css as a dependency
  //  and create a build of your new ReSpec profile.
  //
  // CONFIGURATION
  //  - noReSpecCSS: if you're using a profile that loads this module but you don't want
  //    the style, set this to true
  const styleElement = document.createElement("style");
  styleElement.id = "respec-mainstyle";
  styleElement.textContent = _respec2.default;
  document.head.appendChild(styleElement);

  function run(conf, doc, cb) {
    if (conf.noReSpecCSS) {
      styleElement.remove();
    }
    cb();
  }
});
//# sourceMappingURL=style.js.map;
